<template>
  <div class="filter"
       :class="showFilter?'filter-show':''">
    <div class="filter-container">
      <div class="header">
        <el-button type="text"
                   @click="closeFilter"
                   icon="el-icon-close"></el-button>
        <span>{{$t('layout.Filter')}}</span>
        <el-button type="text"
                   @click="clearFilter">{{$t('layout.Clearfilter')}}</el-button>
      </div>
      <div class="content">
        <myScroll style="width:100%;height:100%">
          <div class="form-list">
            <slot name="form"></slot>
          </div>
        </myScroll>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showFilter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    closeFilter () {
      this.$emit('closeFilter')
    },
    clearFilter () {
      this.$emit('clearFilter')
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
.filter {
  width: 30%;
  transition: all 0.5s;
  position: absolute;
  right: -30%;
  top: 123px;
  bottom: 0;
  background-color: #f8fafb;
  .filter-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-left: 1px solid #dcdfe6;
    .header {
      padding: 0 10px;
      height: 36px;
      overflow: hidden;
      border-bottom: 1px solid #dcdfe6;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
    }
    .content {
      flex: 1;
      height: 0;
    }
    .form-list {
      padding: 0 15px 15px;
    }
  }
}
.filter-show {
  right: 0;
}
</style>
